import React, { FunctionComponent } from 'react';
import { FlexInset, PageTitleHelmet } from '@/components';
import { APP_ROUTES } from '@/config/constants';
import { useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { useLogin } from '@/hooks';
import { useSnackbar } from '@/design-system';
import MagicLinkSuccess from './MagicLinkSuccess';

export const MagicLinkSuccessContainer: FunctionComponent = () => {
  const navigate = useNavigate();
  const { requestMagicLink } = useLogin();
  const showToast = useSnackbar();
  const { email } = queryString.parse(window.location.search);

  const goBackUrl = APP_ROUTES.login;

  const updateEmail = () => {
    navigate(goBackUrl);
  };

  const resendLink = async () => {
    const magicLinkGenerated = await requestMagicLink(email!.toString());
    if (magicLinkGenerated) {
      showToast({ message: 'Your email is on its way.' });
      return;
    }
    showToast({
      message:
        'Unfortunately, something went wrong and we were unable to send the email. Please try again.',
    });
  };

  if (!email) {
    navigate(APP_ROUTES.login);
  }

  return (
    <FlexInset>
      <PageTitleHelmet>Magic Link Success</PageTitleHelmet>
      <MagicLinkSuccess
        email={email?.toString() || ''}
        resendMagicLinkHandler={resendLink}
        updateEmailHandler={updateEmail}
      />
    </FlexInset>
  );
};
